import { StarsButton } from '@ps/web-shared-components';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import { usePokerSpinAndGoWidget } from '../../../model';
import { ModalRoute } from '../../../types';
import Ticker from '../Ticker/Ticker';
import styles from '../shared.scss';

import { Icon } from './Icon';
import { TXTCLI_Watch_Games } from './WatchGamesButton.messages.json';

export const WatchGamesButton: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetSelect, widgetId } = usePokerSpinAndGoWidget();
  const tickerMessage = useSelector(widgetSelect.tickerMessage);
  const [watchGamesHovered, setWatchGamesHovered] = useState<boolean | undefined>(undefined);

  const handleWatchGamesOpen = useCallback(
    () =>
      modal.enqueue({
        path: ModalRoute.WatchGames,
        locationState: { activeTab: tickerMessage?.tabType, widgetId }
      }),
    [modal, tickerMessage, widgetId]
  );

  return (
    <div
      className={styles.watchGamesContent}
      onMouseEnter={() => setWatchGamesHovered(true)}
      onMouseLeave={() => setWatchGamesHovered(false)}
      onClick={handleWatchGamesOpen}
    >
      <Ticker />
      <Icon isHovered={watchGamesHovered} />
      <StarsButton
        translation={TXTCLI_Watch_Games}
        variant="text"
        size="small"
        iconPosition="before"
        className={styles.watchGamesButton}
      />
    </div>
  );
};
